import Api from "~/service/Api";

class UiMeet3dWsTokenRepository {
  fetchOne(tourId) {
    return Api.get(`/ui-meet-3d/ws-tokens/${tourId}`);
  }
}

export default UiMeet3dWsTokenRepository;
